// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 500px) {
    .scl--jpmcs-res-sh-st{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--jmcs-lis-ite-ca-eac-st{
        padding: var(--global-mobile-padding-left);
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-position/css/jobPositionSm.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,0CAA0C;IAC9C;AACJ","sourcesContent":["@media (max-width: 500px) {\n    .scl--jpmcs-res-sh-st{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--jmcs-lis-ite-ca-eac-st{\n        padding: var(--global-mobile-padding-left);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
